import {Pageable, PageModel} from "@/api/Paging.ts";
import Encounter from "@/encounter/model/Encounter.ts";

import {http} from "@/api/HttpClient.ts";
import {ViewPort} from "@/encounter/model/ViewPort.ts";
import {DungeonSettings} from "@/encounter/model/DungeonSettings.ts";
import {AreaEffect} from "@/encounter/model/AreaEffect.ts";
import {Dungeon} from "@/dungeons/model/Dungeon.ts";
import type {EncounterAnnotation} from "@/encounter/model/EncounterAnnotation.ts";

export async function searchEncounters(pageable: Pageable, params?: EncounterFilterParams): Promise<PageModel<Encounter>> {
    const res = await http.get<PageModel<Encounter>>("/encounters", {params: {...pageable, ...params}})
    return res.data
}

export async function getEncounterById(id: string, signal?: AbortSignal): Promise<Encounter> {
    const res = await http.get<Encounter>(`/encounters/${id}`, {signal});
    return res.data;
}

export async function saveEncounter(encounter: Encounter): Promise<void> {
    await http.post("/encounters", encounter);
}

export async function deleteEncounter(id: string): Promise<void> {
    await http.delete<Encounter>(`/encounters/${id}`);
}

export async function saveViewPort(encounter: Encounter, viewPort: ViewPort): Promise<void> {
    await http.post(`/encounters/${encounter.id}/viewPort`, viewPort);
}

export async function getDungeonSettings(encounter: Encounter): Promise<DungeonSettings> {
    const res = await http.get<DungeonSettings>(`/encounters/${encounter.id}/dungeonSettings`);
    return res.data;
}

export async function getEncounterDungeon(encounter: Encounter): Promise<Dungeon> {
    const response = await http.get<Dungeon>(`/encounters/${encounter.id}/dungeon`);
    return response.data;
}

export async function saveDungeonSettings(encounter: Encounter, dungeonSettings: DungeonSettings): Promise<DungeonSettings> {
    const response = await http.post<DungeonSettings>(`/encounters/${encounter.id}/dungeonSettings`, dungeonSettings);
    return response.data;
}

export async function getAreaEffects(encounter: Encounter): Promise<AreaEffect[]> {
    const res = await http.get<AreaEffect[]>(`/encounters/${encounter.id}/effects`);
    return res.data;
}

export async function saveAreaEffect(encounter: Encounter, effect: AreaEffect): Promise<AreaEffect> {
    const response = await http.post<AreaEffect>(`/encounters/${encounter.id}/effects`, effect);
    return response.data;
}

export async function deleteAreaEffect(encounter: Encounter, effectId: string): Promise<string> {
    const response = await http.delete<string>(`/encounters/${encounter.id}/effects/${effectId}`);
    return response.data;
}

export async function getEncounterAnnotations(encounterId: string): Promise<EncounterAnnotation[]> {
    const response = await http.get<EncounterAnnotation[]>(`/encounters/${encounterId}/annotations`);
    return response.data;
}

export async function saveEncounterAnnotation(encounterId: string, annotation: EncounterAnnotation): Promise<EncounterAnnotation> {
    const response = await http.post<EncounterAnnotation>(`/encounters/${encounterId}/annotations`, annotation);
    return response.data;
}

export async function deleteEncounterAnnotation(encounterId: string, annotationId: string): Promise<void> {
    await http.delete(`/encounters/${encounterId}/annotations/${annotationId}`,
        {errorPresentation: "toast", errorMessage: "Die Annotation konnte nicht gelöscht werden."});
}

export interface EncounterFilterParams {
    campaignId?: string;
    name?: string;
}
